<div class="component-box" *ngIf="isSearchVisible">
  <form (ngSubmit)="onSearch()" class="search-form">
    <div class="search-fields">
      <mat-form-field appearance="fill">
        <mat-label>Username</mat-label>
        <input matInput [(ngModel)]="searchForm.userName" name="userName" placeholder="Search by username">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Full Name</mat-label>
        <input matInput [(ngModel)]="searchForm.fullName" name="fullName" placeholder="Search by full name">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="searchForm.email" name="email" placeholder="Search by email">
      </mat-form-field>
    </div>

    <div class="search-actions">
      <button mat-flat-button color="primary" type="submit">
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button mat-flat-button type="button" class="nrg-error-flat-button"  (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </form>
</div>
